import type { IconSvgObject } from './types';

const ListChevronsDownUpIcon: IconSvgObject = [
  ["path", { d: "M15 6.00002C15 6.00002 17.2095 8.99999 18 9C18.7906 9.00001 21 6 21 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 18C15 18 17.2095 15 18 15C18.7906 15 21 18 21 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 6H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11 12H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M11 18H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ListChevronsDownUpIcon;
